import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { BookOpen, FileText, Users, BookMarked } from 'lucide-react';
import { OptimizedImage } from '../components/ui/optimized-image';
const PublicationsCategories = () => {
  const [headerImageUrl, setHeaderImageUrl] = useState(null);

  useEffect(() => {
    // Récupérer l'image header de la page depuis le backend
    const fetchPageHeader = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site/pages/categories-publications`);
        if (response.ok) {
          const data = await response.json();
          if (data.header_image) {
            setHeaderImageUrl(`${process.env.REACT_APP_BACKEND_URL}/api/files/${data.header_image}`);
          }
        }
      } catch (error) {
        console.error('Erreur chargement header image:', error);
      }
    };

    fetchPageHeader();
  }, []);

  // Catégories fixes basées sur les rubriques par défaut
  const categories = [
    {
      id: 'le-bulletin',
      name: 'Le Bulletin',
      description: 'Le bulletin officiel des Lignages de Bruxelles',
      icon: BookOpen,
      route: '/publications/bulletin'
    },
    {
      id: 'le-valet',
      name: 'Le Valet',
      description: 'Publication du Valet',
      icon: FileText,
      route: '/publications/valet'
    },
    {
      id: 'les-filiations-lignageres',
      name: 'Les filiations lignagères',
      description: 'Documentation des filiations lignagères',
      icon: Users,
      route: '/publications/filiations'
    },
    {
      id: 'vade-mecum',
      name: 'Vade-mecum',
      description: 'Guide pratique et aide-mémoire',
      icon: BookMarked,
      route: '/publications/vade-mecum'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header image section */}
      {headerImageUrl && (
        <div 
          className="relative w-full overflow-hidden"
          style={{ 
            height: '600px',
            marginTop: '-80px',
            paddingTop: '80px'
          }}
        >
          <OptimizedImage 
            src={headerImageUrl}
            alt="Publications"
            className="absolute inset-0 w-full h-full object-cover"
            priority={true}
            placeholder="blur"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center" style={{ paddingTop: '100px' }}>
            <h1 
              className="text-5xl font-bold text-center px-4"
              style={{ 
                fontFamily: '"Lora", serif',
                color: 'rgb(196, 150, 96)',
                textShadow: '3px 3px 6px rgba(0,0,0,0.8), -1px -1px 2px rgba(255,255,255,0.3)'
              }}
            >
              Publications
            </h1>
            <p 
              className="text-2xl text-center px-4 mt-3"
              style={{ 
                fontFamily: '"Lora", serif',
                color: 'white',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
              }}
            >
              Découvrez nos publications classées par catégories
            </p>
          </div>
        </div>
      )}

      <div className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header sans image */}
          {!headerImageUrl && (
            <div className="text-center mb-12">
              <h1 
                className="text-5xl font-bold mb-4"
                style={{ fontFamily: '"Lora", serif', color: 'rgb(196, 150, 96)' }}
              >
                Publications
              </h1>
              <p 
                className="text-gray-600 text-lg max-w-2xl mx-auto"
                style={{ fontFamily: '"Lora", serif' }}
              >
                Découvrez nos publications classées par catégories
              </p>
            </div>
          )}

          {/* Grille de catégories */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {categories.map((category) => {
              const Icon = category.icon;
              
              return (
                <Card 
                  key={category.id}
                  className="hover:shadow-xl transition-shadow cursor-pointer"
                  onClick={() => window.location.href = category.route}
                >
                  <CardHeader>
                    <div className="flex items-center space-x-4">
                      <div 
                        className="p-3 rounded-lg"
                        style={{ backgroundColor: 'rgba(196, 150, 96, 0.1)' }}
                      >
                        <Icon 
                          className="w-8 h-8" 
                          style={{ color: 'rgb(196, 150, 96)' }}
                        />
                      </div>
                      <div className="flex-1">
                        <CardTitle 
                          className="text-2xl"
                          style={{ fontFamily: '"Lora", serif', color: 'rgb(196, 150, 96)' }}
                        >
                          {category.name}
                        </CardTitle>
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <p 
                      className="text-gray-600 mb-4"
                      style={{ fontFamily: '"Lora", serif' }}
                    >
                      {category.description}
                    </p>
                    <Button
                      className="w-full text-white"
                      style={{ backgroundColor: 'rgb(196, 150, 96)' }}
                    >
                      Voir les publications
                    </Button>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          {/* Bouton retour */}
          <div className="text-center mt-12">
            <Button
              variant="outline"
              onClick={() => window.location.href = '/'}
              style={{ 
                borderColor: 'rgb(196, 150, 96)',
                color: 'rgb(196, 150, 96)'
              }}
            >
              Retour à l'accueil
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicationsCategories;
